import { render, staticRenderFns } from "./ForeWarning.vue?vue&type=template&id=49cdcfb6&scoped=true&"
import script from "./ForeWarning.vue?vue&type=script&lang=js&"
export * from "./ForeWarning.vue?vue&type=script&lang=js&"
import style0 from "./ForeWarning.vue?vue&type=style&index=0&id=49cdcfb6&prod&lang=scss&scoped=true&"
import style1 from "./ForeWarning.vue?vue&type=style&index=1&id=49cdcfb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cdcfb6",
  null
  
)

export default component.exports